import { getPagePath, trans } from '@spotahome/soyuz/client';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';
import GridInfo from '@spotahome/ui-library/src/tenant/components/GridInfo';

import HeadphonesIcon from './Icons/HeadphonesIcon';
import CompassIcon from './Icons/CompassIcon';

import './Help.scss';

const Help = () => {
  const gridItems = [
    {
      label: 'SPOTAHOME BLOG',
      title: trans('tenant_guarantees.help.block1.title'),
      description: trans('tenant_guarantees.help.block1.description'),
      cta: {
        text: trans('tenant_guarantees.help.read.article'),
        url: getPagePath('externals.blog.avoid-deposit-disputes-guide')
      }
    },
    {
      title: trans('tenant_guarantees.help.block2.title'),
      cta: {
        text: trans('tenant_guarantees.help.block2.cta'),
        url: getPagePath('externals.help-center'),
        type: 'button'
      },
      renderImage: className => <CompassIcon className={className} />,
      hideTitleOnMobile: true
    },
    {
      title: trans('tenant_guarantees.help.block3.title'),
      cta: {
        text: trans('tenant_guarantees.help.block3.cta'),
        url: getPagePath('support-contact-form'),
        type: 'button'
      },
      renderImage: className => <HeadphonesIcon className={className} />,
      hideTitleOnMobile: true
    },
    {
      label: 'SPOTAHOME BLOG',
      title: trans('tenant_guarantees.help.block4.title'),
      description: trans('tenant_guarantees.help.block4.description'),
      cta: {
        text: trans('tenant_guarantees.help.read.article'),
        url: getPagePath('externals.blog.what-guarantees-does-spotahome-offer')
      }
    }
  ];

  return (
    <LandingSection className="tenant-guarantees-help">
      <h2 className="tenant-guarantees-help__title">
        {trans('tenant_guarantees.help.title')}
      </h2>
      <GridInfo items={gridItems} />
    </LandingSection>
  );
};

export default Help;
